import axiosClient from "./axios";

/**
 * Get all active astrologers
 */
export const getAstrologers = async () => {
    try {
        const response = await axiosClient.get(`/module/astrologers`);
        return response.data;
    } catch (error) {
        console.error("Astrologlar alınırken hata:", error);
        throw error;
    }
};

/**
 * Get single astrologer by id or slug
 * @param {string|number} id 
 */
export const getAstrologerDetail = async (id) => {
    try {
        const response = await axiosClient.get(`/module/astrologers/${id}`);
        return response.data;
    } catch (error) {
        console.error("Astrolog detayı alınırken hata:", error);
        throw error;
    }
};
